<template>
  <div class="claim">
    <header>
      <p>
        当前位置：
        <span
          @click="
            () => {
              this.$router.push('/home');
            }
          "
          >个人主页</span
        >
        <span style="margin: 0 10px">></span>
        <span style="color: #0090ff">补充资料</span>
      </p>
    </header>
    <div class="main">
      <p class="title">上传作品证明，增加认领通过率</p>
      <div class="edit">
        <div class="row">
          <div class="left">
            <div class="label center-y">歌曲名</div>
          </div>
          <div class="right">
            <input class="text" />
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y"></div>
          </div>
          <div class="right">
            <div class="tip">
              <p>1.请勿填写身份信息、歌手名、曲目顺序等非必要内容</p>
              <p>2.如有备注请使用括号，例：歌曲名 (三周年主题曲)</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">曲风</div>
          </div>
          <div class="right">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">语种</div>
          </div>
          <div class="right">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">版本</div>
          </div>
          <div class="right">
            <div class="radio">
              <el-radio v-model="radio" label="1">男</el-radio>
              <el-radio v-model="radio" label="2">女</el-radio>
              <el-radio v-model="radio" label="3">组合</el-radio>
              <el-radio v-model="radio" label="4">虚拟</el-radio>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">歌手</div>
          </div>
          <div class="right">
            <input class="text" />
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">作词</div>
          </div>
          <div class="right">
            <input class="text" placeholder="请输入作词人姓名" />
            <el-checkbox v-model="checked">我是作词人</el-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">作曲</div>
          </div>
          <div class="right">
            <input class="text" placeholder="请输入作曲人姓名" />
            <el-checkbox v-model="checked">我是作曲人</el-checkbox>
          </div>
        </div>
        <div class="row" style="height: 160px">
          <div class="left">
            <div class="label center-y">简介</div>
          </div>
          <div class="right">
            <div class="textarea">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
                resize="none"
                v-model="desciption"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y"></div>
          </div>
          <div class="right">
            <div class="btn submit">提交</div>
            <div class="btn back">返回</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      desciption: "",
      checked: false,
      radio: "1",
      value: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.claim {
  header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    border-radius: 10px;
    background-color: #fff;
    p {
      margin-left: 20px;
      span {
        cursor: pointer;
      }
    }
  }
  > .main {
    position: relative;
    margin-top: 5px;
    border-radius: 10px;
    background-color: #fff;
    height: calc(100vh - 70px);
    overflow: auto;
    .title {
      position: relative;
      margin: 30px 0 0 20px;
      font-size: 18px;
      color: #000;
    }
    .edit {
      margin-left: 20px;
      margin-top: 50px;
      .row {
        position: relative;
        display: flex;
        margin-top: 20px;
        height: 40px;
        > div {
          position: relative;
          height: 100%;
        }
        .left {
          flex-basis: 100px;
          font-size: 16px;
          color: #000000;
          .label {
          }
        }
        .right {
          font-size: 16px;
          .el-select {
            width: 470px;
          }
          .radio {
            line-height: 40px;
          }
          .tip {
            p {
              font-size: 14px;
              color: #888888;
            }
          }
          .text {
            width: 450px;
            height: auto;
            min-height: 38px;
            line-height: 38px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
          .textarea {
            width: 470px;
          }
          textarea {
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
          .btn {
            float: left;
            width: 140px;
            height: 40px;
            font-size: 16px;
            text-align: center;
            line-height: 40px;
            border-radius: 20px;
          }
          .submit {
            background-color: #0090ff;
            color: #fff;
            margin-right: 20px;
          }
          .back {
            border: 1px solid rgba(0, 0, 0, 0.1);
            color: #000;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Claim.vue